import { produce } from 'immer'
import {
  CREATE_ORG_CONNECTION_INTENT_FAILURE,
  CREATE_ORG_CONNECTION_INTENT_INIT,
  CREATE_ORG_CONNECTION_INTENT_SUCCESS,
  CREATE_ORG_INTEGRATION_FAILURE,
  CREATE_ORG_INTEGRATION_INIT,
  CREATE_ORG_INTEGRATION_SUCCESS,
  CreateOrgConnectionIntentActions,
  CreateOrgIntegrationActions,
} from 'src/app/CreateOrgIntegration/redux/createOrgIntegration.actions'
import { OrganizationConnectionIntentListResponse } from 'src/models/organizationConnectionIntent.models'
import { OrganizationIntegrationListResponse } from 'src/models/organizationIntegration.models'
import { createOrgIntegrationRouteProps } from 'src/navigation/routeProps'
import { createFlyoutReducer } from 'src/redux/genericReducers'

export interface CreateOrgIntegrationState {
  loading: boolean
  error: boolean
  connectionIntent?: OrganizationConnectionIntentListResponse
  orgIntegration?: OrganizationIntegrationListResponse
}

export const initialState: CreateOrgIntegrationState = {
  loading: false,
  error: false,
  connectionIntent: undefined,
  orgIntegration: undefined,
}

export type Actions =
  | CreateOrgConnectionIntentActions
  | CreateOrgIntegrationActions

const CoreCreateOrgIntegrationReducer = (
  state = initialState,
  action: Actions,
): CreateOrgIntegrationState => {
  return produce(state, (draft) => {
    switch (action.type) {
      case CREATE_ORG_CONNECTION_INTENT_INIT: {
        draft.error = false
        draft.loading = true
        return draft
      }
      case CREATE_ORG_CONNECTION_INTENT_SUCCESS: {
        draft.error = false
        draft.loading = false
        draft.connectionIntent = action.payload.connectionIntent
        return draft
      }
      case CREATE_ORG_CONNECTION_INTENT_FAILURE: {
        draft.error = true
        draft.loading = false
        draft.connectionIntent = undefined
        return draft
      }
      case CREATE_ORG_INTEGRATION_INIT: {
        draft.error = false
        draft.loading = true
        return draft
      }
      case CREATE_ORG_INTEGRATION_SUCCESS: {
        draft.error = false
        draft.loading = false
        draft.orgIntegration = action.payload.organizationConnection
        return draft
      }
      case CREATE_ORG_INTEGRATION_FAILURE: {
        draft.error = true
        draft.loading = false
        return draft
      }
    }
  })
}

const CreateOrgIntegrationReducer = createFlyoutReducer(
  createOrgIntegrationRouteProps,
  initialState,
  CoreCreateOrgIntegrationReducer,
)

export default CreateOrgIntegrationReducer
